<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <license-form-box
        list-url="/license-upload"
        :id="id"
        license-type="license"
        :formType="formType"
        @add="onAdd"
        @edit="onEdit"
      ></license-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LicenseFormBox from '../../components/LicenseFormBox.vue';

export default {
  name: 'LicenseForm',
  components: {
    LicenseFormBox
  },
  async mounted() {
    if (this.$route.name === 'license-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'license',
        id: this.id,
        router: this.$router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Upload New License' : 'Update License';
    },
    ...mapState('license', ['loading'])
  },
  methods: {
    ...mapActions('license', ['getOne', 'postOne', 'patchOne']),
    onAdd({ license }) {
      this.postOne({
        license,
        router: this.$router,
        redirectUrl: '/license-upload'
      });
    },
    onEdit({ license }) {
      this.patchOne({
        type: 'license',
        id: this.id,
        license,
        router: this.$router,
        redirectUrl: '/license-upload'
      });
    }
  }
};
</script>
